import { AmenitySvg, AmenitySvgProps } from "./AmenitySvg";

export function SwimmingPoolIcon(props: AmenitySvgProps) {
  return (
    <AmenitySvg {...props}>
      <path
        d="M25 24H24C22.5486 24 21.278 23.1411 21 22C20.722 23.1411 19.4514 24 18 24C16.5486 24 15.278 23.1411 15 22C14.722 23.1411 13.4514 24 12 24C10.5486 24 9.27796 23.1411 9 22C8.72204 23.1411 7.45137 24 6 24H5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L21.7351 6.0883C20.4151 6.52832 19.755 6.74832 19.3775 7.2721C19 7.79587 19 8.49159 19 9.88304L19 20"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 6L13.7351 6.0883C12.4151 6.52832 11.755 6.74832 11.3775 7.2721C11 7.79587 11 8.49159 11 9.88304L11 20"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 10L19 10M11 14L19 14M11 18H19"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </AmenitySvg>
  );
}
